import script from "./PickSubCategoryForJob.vue?vue&type=script&setup=true&lang=js"
export * from "./PickSubCategoryForJob.vue?vue&type=script&setup=true&lang=js"

import "./PickSubCategoryForJob.vue?vue&type=style&index=0&id=3b989b84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b989b84"]])

export default __exports__